export default __webpack_public_path__ + "static/media/img1.c9bfb59e.jpg";